import {
    HeaderCloseIconWrapper,
    HeaderTOFIconWrapper,
    HeaderRow,
    ManuContainer,
    MenuIconWrapper,
    MenuRow, TgWrapper, WebSiteWrapper, SupportWrapper, PromoWrapper, LangWrapper, FeedbackWrapper, TermsWrapper,
    MenuFooterContainer, HeaderAndMianBlock,
} from "./Menu.styled";
import {ReactComponent as TOFManuLogo} from "../../assets/icons/menu_logo.svg";
import {ReactComponent as CloseMenu} from "../../assets/icons/close_menu.svg";
import {ReactComponent as TgIcon} from "../../assets/icons/tg_icon.svg";
import {ReactComponent as WebIcon} from "../../assets/icons/web.svg";
import {ReactComponent as SponsorIcon} from "../../assets/icons/sponsor.svg";
import {ReactComponent as PromoIcon} from "../../assets/icons/promo.svg";
import {ReactComponent as LangIcon} from "../../assets/icons/lang.svg";
import {ReactComponent as FeedbackIcon} from "../../assets/icons/feedback.svg";
import {ReactComponent as RulesIcon} from "../../assets/icons/rules.svg";
import {useAppDispatch} from "../../redux/store";
import {setIsLangOpen, setIsMenuOpen} from "../../redux/actions";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {Language} from "./Language/Langauge";
import {LANG_KEY} from "../../constants";
import {AppText} from "../../utils";

export const Menu: React.FC<{ isMobile: boolean }> = ({isMobile}) => {
    const dispatch = useAppDispatch()
    const isLangOpen = useSelector(selectors.selectIsLangOpen)
    const lang = useSelector(selectors.selectLang)
    return (
        <ManuContainer isMobile={isMobile}>
            <HeaderAndMianBlock>
                <HeaderRow>
                    <HeaderTOFIconWrapper>
                        <TOFManuLogo/>
                    </HeaderTOFIconWrapper>
                    <HeaderCloseIconWrapper>
                        <CloseMenu onClick={() => dispatch(setIsMenuOpen(false))}/>
                    </HeaderCloseIconWrapper>
                </HeaderRow>
                {isLangOpen && (
                    <Language/>
                )}
                {!isLangOpen && (
                    <>
                        <MenuRow isDone={true}>
                            <TgWrapper isDone={true}>
                                <TgIcon/>
                            </TgWrapper>
                            <span>{AppText[lang].menu.a}</span>
                        </MenuRow>
                        <MenuRow isDone={false}>
                            <WebSiteWrapper isDone={false}>
                                <WebIcon/>
                            </WebSiteWrapper>
                            <span>{AppText[lang].menu.b}</span>
                        </MenuRow>
                        <MenuRow isDone={false}>
                            <SupportWrapper isDone={false}>
                                <SponsorIcon/>
                            </SupportWrapper>
                            <span>{AppText[lang].menu.c}</span>
                        </MenuRow>
                        <MenuRow isDone={false}>
                            <PromoWrapper isDone={false}>
                                <PromoIcon/>
                            </PromoWrapper>
                            <span>{AppText[lang].menu.d}</span>
                        </MenuRow>
                        <MenuRow
                            onClick={() => {
                                dispatch(setIsLangOpen(!isLangOpen))
                            }}
                            isDone={true}
                        >
                            <LangWrapper isDone={true}>
                                <LangIcon/>
                            </LangWrapper>
                            <span>{AppText[lang].menu.e}</span>
                        </MenuRow>
                        <MenuRow isDone={false}>
                            <FeedbackWrapper isDone={false}>
                                <FeedbackIcon/>
                            </FeedbackWrapper>
                            <span>{AppText[lang].menu.f}</span>
                        </MenuRow>
                        <MenuRow isDone={false}>
                            <TermsWrapper isDone={false}>
                                <RulesIcon/>
                            </TermsWrapper>
                            <span>{AppText[lang].menu.g}</span>
                        </MenuRow>
                    </>
                )
                }
            </HeaderAndMianBlock>
            <MenuFooterContainer>
                <div>
                    TOF VERSION 0.1
                </div>
                <div>
                    © 2026 TRADE OPTION FLOW
                </div>
            </MenuFooterContainer>
        </ManuContainer>
    )
}